import { render, staticRenderFns } from "./MerchantCategory.vue?vue&type=template&id=7b514a83&"
import script from "./MerchantCategory.vue?vue&type=script&lang=js&"
export * from "./MerchantCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports